module.exports = __webpack_public_path__ + "img/delete_12x12.b348a6b6.svg";